class State
    constructor: (el) ->
        @.$el = el

        @.state = parseInt @.$el.dataset?.state, 10
        @.state = if !isNaN(@.state) then @.state else 0

        @.InitEvents()
        @.$el.classList.add 'state--bound'
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'state-change-state', (e) ->
            newState = parseInt e.detail?.state, 10
            if !isNaN(newState)
                self.state = newState
                self.$el.dataset.state = newState
            return
        @.$el.addEventListener 'state-change-text', (e) ->
            newText = e.detail?.text ? false
            if newText
                self.$el.querySelector '.state__text'
                    .innerHTML = newText
            return
        return
    
BindStates = ->
    document.querySelectorAll '.state:not(.state--bound)'
        .forEach (el) ->
            new State el
            return
    return

window.addEventListener 'bind-components', BindStates